import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=9788cc4a&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=9788cc4a&prod&lang=scss&"
import style1 from "./Editor.vue?vue&type=style&index=1&id=9788cc4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9788cc4a",
  null
  
)

export default component.exports